var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ModificarCronograma"),
      _vm._v(" "),
      _c("AnularCronograma"),
      _vm._v(" "),
      _c("EnviarCronograma"),
      _vm._v(" "),
      _c("Ver"),
      _vm._v(" "),
      _c("crear-actualizar-vacaciones"),
      _vm._v(" "),
      _c("h4", { staticClass: "primary--text" }, [
        _c("span", { staticClass: "material-symbols-outlined span-icon" }, [
          _vm._v("\n      calendar_month\n    ")
        ]),
        _vm._v(
          "\n    Programación de vacaciones " +
            _vm._s(_vm.gestion_parametro) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "px-0 py-2 grey lighten-2 text--info" },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", color: "primary", to: "/vacaciones" }
                    },
                    [_c("v-icon", [_vm._v("arrow_back")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("strong", [_vm._v(" Listado de gestiones")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "px-3 py-1" },
            [
              !!_vm.estado_vacacion.id
                ? _c("DatosPersonalesProgramacion", {
                    attrs: { id_estado_vacacion: _vm.estado_vacacion.id },
                    model: {
                      value: _vm.total_dias_programar,
                      callback: function($$v) {
                        _vm.total_dias_programar = $$v
                      },
                      expression: "total_dias_programar"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "text-xs-center py-1" },
            [
              _c(
                "v-card",
                { staticClass: "px-3 white--text", attrs: { color: "indigo" } },
                [
                  _c("span", { staticClass: "caption" }, [
                    _vm._v("NÚMERO DE DÍAS RESTANTES A PROGRAMAR")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "display-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.total_dias_programar - _vm.total_dias_programados
                      )
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        color: "primary",
                        disabled:
                          !(
                            _vm.estado_vacacion.id_estado_programacion == 22 ||
                            _vm.estado_vacacion.id_estado_programacion == 47
                          ) || _vm.bandera_rango_fecha == false
                      },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.crearActualizarVacaciones({})
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(" Nuevo")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        color: "primary",
                        disabled:
                          !(
                            _vm.estado_vacacion.id_estado_programacion == 22 ||
                            _vm.estado_vacacion.id_estado_programacion == 47
                          ) || _vm.bandera_rango_fecha == false
                      },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.enviarCronograma()
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("send")]),
                      _vm._v(" Enviar")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator" },
                      nativeOn: {
                        click: function($event) {
                          return function() {
                            _vm.filterShow = _vm.filterShow ? false : true
                          }.apply(null, arguments)
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("filter_list")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Búsqueda/filtros")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cargarProgramaciones()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container-rrhh"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nro papeleta" },
                              on: { input: _vm.filterSecuencia },
                              model: {
                                value: _vm.form.secuencia,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "secuencia", $$v)
                                },
                                expression: "form.secuencia"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha salida" },
                              on: { input: _vm.filterFechaDesde },
                              model: {
                                value: _vm.form.ap_paterno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_paterno", $$v)
                                },
                                expression: "form.ap_paterno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Fecha fin" },
                              on: { input: _vm.filterFechaHasta },
                              model: {
                                value: _vm.form.fecha_hasta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fecha_hasta", $$v)
                                },
                                expression: "form.fecha_hasta"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Dias" },
                              on: { input: _vm.filterTotalDias },
                              model: {
                                value: _vm.form.total_dias,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_dias", $$v)
                                },
                                expression: "form.total_dias"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Estado" },
                              on: { input: _vm.filterEstado },
                              model: {
                                value: _vm.form.estado,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "estado", $$v)
                                },
                                expression: "form.estado"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      small: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.recargar()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("refresh")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Recargar filtros")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return function() {
                                          _vm.filterShow = false
                                          _vm.recargar()
                                        }.apply(null, arguments)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_programaciones,
                  "hide-actions": "",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.secuencia))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_desde)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_hasta)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.total_dias))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            (items.item.id_estado == 22 ||
                              items.item.id_estado == 47) &&
                            _vm.bandera_rango_fecha
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "green",
                                      dark: "",
                                      icon: "",
                                      title: "Modificar"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.modificarProgramacion(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            (items.item.id_estado == 22 ||
                              items.item.id_estado == 47) &&
                            _vm.bandera_rango_fecha
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "red",
                                      dark: "",
                                      icon: "",
                                      title: "Anular"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.anularCronograma(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _c(
                          "td",
                          {
                            staticClass: "footer-table",
                            attrs: { colspan: "3" }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s("Total dias programados"))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center title" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.total_dias_programados))
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9537e5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9537e5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/Programar.vue
// module id = null
// module chunks = 